/* Fietstotaal Premium Footer V5 - Mailchimp nieuwsbrief */
(function () {
  'use strict';

  var POPUP_SUBSCRIBED_KEY = 'ft_discount_popup_subscribed';
  var POPUP_HIDDEN_KEY = 'ft_discount_popup_hidden_until';
  var FOOTER_SUBSCRIBED_KEY = 'ft_footer_newsletter_subscribed';

  function cleanMessage(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').trim();
  }

  function setLoading(button, textEl, loadingEl, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    if (textEl) textEl.hidden = isLoading;
    if (loadingEl) loadingEl.hidden = !isLoading;
  }

  function showMessage(messageEl, text, isError) {
    if (!messageEl) return;
    messageEl.textContent = text || '';
    messageEl.hidden = !text;
    messageEl.classList.toggle('is-error', !!isError);
    messageEl.classList.toggle('is-success', !!text && !isError);
  }

  function submitToMailchimp(url, email, botName, botValue) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        reject(new Error('Mailchimp is nog niet gekoppeld.'));
        return;
      }

      var callbackName = 'ftFooterMailchimp_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
      var script = document.createElement('script');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      window[callbackName] = function (response) {
        cleanup();
        resolve(response || {});
      };

      function cleanup() {
        if (script.parentNode) script.parentNode.removeChild(script);
        try {
          delete window[callbackName];
        } catch (error) {
          window[callbackName] = undefined;
        }
      }

      script.onerror = function () {
        cleanup();
        reject(new Error('Mailchimp kon niet worden bereikt.'));
      };

      script.src =
        url +
        separator +
        'EMAIL=' + encodeURIComponent(email) +
        '&' + encodeURIComponent(botName || '') + '=' + encodeURIComponent(botValue || '') +
        '&c=' + encodeURIComponent(callbackName);

      document.body.appendChild(script);
    });
  }

  function initFooterNewsletter(form) {
    var card = form.closest('.ft-footer-v3__newsletter-card') || document;
    var message = card.querySelector('[data-ft-footer-message]');
    var submitButton = form.querySelector('[data-ft-footer-submit]');
    var submitText = form.querySelector('[data-ft-footer-submit-text]');
    var submitLoading = form.querySelector('[data-ft-footer-submit-loading]');
    var formScreen = card.querySelector('[data-ft-footer-form-screen]');
    var successScreen = card.querySelector('[data-ft-footer-success-screen]');
    var emailInput = form.querySelector('input[type="email"]');
    var botInput = form.querySelector('input[name^="b_"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = emailInput ? emailInput.value.trim() : '';
      var botName = botInput ? botInput.name : '';
      var botValue = botInput ? botInput.value : '';
      var url = form.getAttribute('data-mailchimp-url') || '';

      if (!emailInput || !emailInput.checkValidity() || !email) {
        if (emailInput) emailInput.reportValidity();
        return;
      }

      setLoading(submitButton, submitText, submitLoading, true);
      showMessage(message, '', false);

      submitToMailchimp(url, email, botName, botValue)
        .then(function (response) {
          var result = response.result || '';
          var msg = cleanMessage(response.msg || '');
          var alreadySubscribed = /already subscribed|is already subscribed|reeds ingeschreven|al ingeschreven/i.test(msg);

          if (result === 'success' || alreadySubscribed) {
            try {
              localStorage.setItem(POPUP_SUBSCRIBED_KEY, 'true');
              localStorage.setItem(FOOTER_SUBSCRIBED_KEY, 'true');
              localStorage.removeItem(POPUP_HIDDEN_KEY);
            } catch (error) {}

            if (formScreen) formScreen.hidden = true;
            if (successScreen) successScreen.hidden = false;
            return;
          }

          showMessage(message, msg || 'Controleer je e-mailadres en probeer het opnieuw.', true);
        })
        .catch(function () {
          showMessage(message, 'Er ging iets mis met inschrijven. Probeer het straks opnieuw.', true);
        })
        .finally(function () {
          setLoading(submitButton, submitText, submitLoading, false);
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-ft-footer-newsletter-form]');
    forms.forEach(initFooterNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
